import Success from "@/assets/static/success.svg";
const SuccessIcon = () => {
  return (
    <Success/>
  );
};
export default SuccessIcon;
